import { gql, TypedDocumentNode } from "@apollo/client";

import { Plugin, PluginTemplate } from "types/generated";

export const CREATE_PLUGIN_TEMPLATE: TypedDocumentNode<{ pluginTemplateCreate: PluginTemplate }> =
  gql`
    mutation CreatePlugin($input: PluginTemplateCreateInput!) {
      pluginTemplateCreate(input: $input) {
        id
      }
    }
  `;

export const GET_PLUGIN_TEMPLATES: TypedDocumentNode<{
  pluginTemplates: PluginTemplate[];
}> = gql`
  query GetPluginTemplates {
    pluginTemplates {
      createdAt
      description
      id
      isGlobal
      labels
      manifest
      name
      parameters {
        default
        description
        id
        name
        required
        sensitive
        type
      }
    }
  }
`;

export const INSTALL_PLUGIN_TEMPLATE: TypedDocumentNode<{ pluginInstall: Plugin }> = gql`
  mutation InstallPlugin($input: PluginInstallInput!) {
    pluginInstall(input: $input) {
      id
    }
  }
`;

export const DELETE_PLUGIN_TEMPLATE: TypedDocumentNode<{ pluginTemplateDelete: PluginTemplate }> =
  gql`
    mutation DeletePluginTemplate($id: ID!) {
      pluginTemplateDelete(id: $id) {
        id
      }
    }
  `;
